import type { ApiJobSynonymId } from '#/api/types/ApiTypedId';
import type { EstimatedRange } from '#/modules/salary/types/EstimatedRange';
import type { BackgroundTask } from '#/utils/asyncBackendTask/asyncBackendTaskTypes';
import { waitTaskCompleted } from '#/utils/asyncBackendTask/waitTaskCompleted';
import { postJson } from '#/utils/http/postJson';

import { SALARIES_API_ENDPOINT_ROOT } from './salaryApiEndpointRoot';

export async function salaryApiFetchCareerPathSynonyms({
  selectedSynonymId,
  city,
  stateCode,
  yearsOfExperience,
}: {
  selectedSynonymId: ApiJobSynonymId | null;
  city?: string;
  stateCode?: string;
  yearsOfExperience?: number;
  useMock?: boolean;
}): Promise<EstimatedRange[]> {
  const { task } = await postJson<{
    task: BackgroundTask<{ careerPath: EstimatedRange[] }>;
  }>(`${SALARIES_API_ENDPOINT_ROOT}/calculator/career-path/initial`, {
    city,
    stateCode,
    yearsOfExperience,
    selectedSynonymId,
  });

  const { careerPath } = await waitTaskCompleted(task);
  return careerPath;
}
